import {Avatar, Button, DatePicker, Input, Space} from 'antd'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik} from 'formik'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useMemo, useState} from 'react'
import {compose, mapProps} from 'recompose'
import {GenderTypes} from 'views/AppLocals/appFieldTypes'
import {appClassNames} from 'views/AppLocals/custom/appClassNames'
import {ErrorSummaries} from 'views/AppLocals/factory/createEditableForm'
import {createControlledFormField, createPhoneNumberField} from 'views/AppLocals/factory/createFormField'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import AvatarUploader from '../../../Workspace/components/AvatarUploader'
import {
    BsAspectRatio,
    BsCheckCircleFill,
    BsExclamationTriangleFill,
    BsImage,
    BsInfoCircle,
    BsShieldCheck
} from 'react-icons/bs'
import {gConfigs} from '../../configs'
import {IoCalendarOutline, IoImageOutline} from 'react-icons/io5'
import {createValue} from '../../../../components/form/utils'
import {getDateString, parseDayjs} from '../../../../helpers/datetimeHelpers'
import {LookupTagsPicker} from '../../custom/TagsPicker'
import {IdentifierTypes} from '../../appFieldTypes'
import IdentifierCodeLookupField from '../../../../components/IdentifierCodeLookupField'
import {API_ROOT_URL} from '../../../../envs/_current/config'
import {baseItemSchema} from '../../../../apis/schema'
import {createListTransform} from '../../../../apis/utils/createListTransform'
import Pure from '../../../../components/Pure'
import useToggle from 'react-use/lib/useToggle'
import {renderIf} from '../../../Shared'
import ForDevelop from '../../../../envs/ForDevelop'
import UserLookupComponent from '../../../../components/UserLookupComponent'
import {LinkedAccountBadge} from '../../../../components/UserLookupComponent/LinkedAccountBadge'
import {AutoLinkEmailInput} from '../../../../components/UserLookupComponent/AutoLinkEmailInput'
import {RiSearch2Line} from 'react-icons/ri'
import dayjs from 'dayjs'
import {ActionModalWrapper} from '../../../../components/form/ActionModalWrapper'
import LookupField from '../../../../components/LookupField'
import {SaintsOutlineSvg} from '../../../../components/Svgs/SaintsPlaceholder'
import {FaGraduationCap, FaPhone, FaUserTie} from 'react-icons/fa6'
import {
    digitLength,
    eachWordUppercase,
    emailFormat,
    firstLetterUppercase,
    lengthBetween,
    noDoubleSpaces,
    noLeadingTrailingSpaces,
    noSpecialChars,
    passportFormart,
    required,
} from '../../../../components/form/ValidateForm'
import {ChipGroup, Field, Section} from "../../../../components/form/ModernForm";

// Chuẩn hoá kết quả tra cứu tài khoản (userInfo, response THÔ của lookup - _type:'lookup') thành
// patch áp vào form Teacher. DÙNG CHUNG cho 2 nơi gọi tới: ô tìm theo "Tên đầy đủ" (UserLookupComponent,
// admin chủ động bấm "Chọn" trong modal) VÀ ô "Thư điện tử" (AutoLinkEmailInput, admin bấm "Điền
// thông tin & liên kết" trên thẻ gợi ý) - tách hàm ra để 2 luồng không lệch field/tạo 2 nguồn sự thật
// cho cùng 1 việc "áp dữ liệu tài khoản tìm được vào form".
const buildTeacherProfilePatch = (userInfo) => {
    const {
        name,
        email,
        gender,
        phone_number,
        identifier_type,
        identifier_code,
        date_of_birth,
        place_of_birth,
        address,
        patron_saint,
        patron_saint_name,
        parish,
        parish_name,
        diocese,
        diocese_name,
        religious_order,
    } = userInfo ?? {}

    return _.omitBy(
        {
            email,
            gender: _.find(GenderTypes, {value: gender})?.value,
            date_of_birth: !!String(date_of_birth ?? '').length
                ? parseDayjs(date_of_birth)
                : undefined,
            place_of_birth: place_of_birth ?? undefined,
            fullname: !!String(name ?? '').length
                ? name
                : undefined,
            contact_phone: phone_number
                ? phone_number
                : undefined,
            contact_email: email ?? undefined,
            contact_address: address ?? undefined,

            identifier_type: _.find(IdentifierTypes, {
                value: identifier_type,
            })?.value,
            identifier_code: !!String(identifier_code ?? '').length
                ? identifier_code
                : undefined,

            // owner (không phải nguyên userInfo) - userInfo là response THÔ của lookup (_type:'lookup',
            // không có avatar riêng), owner mới đúng shape user tiny thật (_type:'user') mà
            // getTitle/getAvatar/getLinkToDetail cần (khớp StudentForm.js).
            user: userInfo?.owner,
            user_id: userInfo?.id,

            patron_saint: patron_saint,
            patron_saint_id: patron_saint?.id,
            patron_saint_name: patron_saint_name,

            diocese_id: diocese?.id,
            diocese_name: diocese_name,
            diocese: diocese,

            parish_id: parish?.id,
            parish_name: parish_name,
            parish: parish,

            religious_order: religious_order,
            religious_order_id: religious_order?.id,
            religious_order_name: userInfo?.religious_order_name,
        },
        _.isUndefined
    )
}

export const formSchema = {
    avatar: {
        // title: 'avatar',
        children: [
            {
                name: 'avatar',
                className: 'w-fit',
                component: createControlledFormField({
                    withValues: ({avatar_preview}) => ({
                        value: avatar_preview,
                        width: 150,
                        height: 150,
                        icon: (
                            <BsImage
                                size={70}
                                style={{color: '#eaeaea'}}
                            />
                        ),
                    }),
                    cropPurpose: 'avatar',
                    round: true,
                    Component: AvatarUploader,
                }),
            },
        ],
    },
    patron_saint__fullname: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-4 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                // Danh xưng ("Lm.", "Sr.", "Thầy"...) - đứng trước tên khi hiển thị (formatPersonName,
                // educationRoleHelpers.js: prefix_title + patron_saint_name + fullname) nhưng trước
                // đây KHÔNG có field nhập trên form Tạo/Sửa giáo viên dù danh sách vẫn hiện "Lm ..."
                // (bạn phát hiện lỗi này) - free text, BE không giới hạn danh sách cố định (đã kiểm
                // tra Teacher::rules(), chỉ max:255, khác UserProfile::prefix_title có enum riêng).
                label: 'honorific prefix',
                name: 'prefix_title',
                component: createControlledFormField({
                    placeholder: 'ex: honorific prefix',
                    autoComplete: false,
                    Component: Input,
                }),
            },
            {
                label: 'holy name',
                name: 'patron_saint',
                component: ({name, value, onChange, form}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose patron saint')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.patron_saint_name}
                                selectedOption={form?.values?.patron_saint}
                                apiPath={`/lookup/saint/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) => (
                                    <div className="p-3 flex items-center gap-2 lookup-item" {...props}>
                                        {children}
                                    </div>
                                )}
                                renderOption={(o, i) => {
                                    return (
                                        <div key={i} className="flex items-center flex-1 gap-3">
                                            <Avatar
                                                size={40}
                                                src={o.avatar}
                                                className="flex flex-center bg-secondary-50 rounded-lg"
                                                icon={<SaintsOutlineSvg size={20} style={{color: 'var(--color-secondary-400)'}}/>}
                                            />
                                            <div className="flex flex-col flex-1">
                                                <span className="font-bold text-sm text-color-000 leading-snug">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                </span>
                                                {renderIf(
                                                    o?.description,
                                                    <span className="text-xs text-color-400 italic max-lines-1">
                                                        {o?.description}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        patron_saint: e.target,
                                        patron_saint_name: e.target.common_name || e.target.value,
                                        patron_saint_feast_day: e.target.feast_day,
                                        patron_saint_id: e.target.id,
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'fullname',
                name: 'fullname',
                isRequired: true,
                component: ({name, value, form, onChange}) => (
                    <Translate>
                        {(t) => (
                            <div className="flex flex-col gap-1">
                                <Space.Compact
                                    style={{display: 'inline-flex', alignItems: 'center'}}
                                    className="custom-input-group">
                                    <Input
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        allowClear={true}
                                        placeholder={t('Enter your name')}
                                        style={{borderRadius: '0.375rem 0 0 0.375rem'}}
                                        className="flex-1"
                                    />
                                    <UserLookupComponent
                                        handleApply={(userInfo) => {
                                            const {values, setValues} = form ?? {}
                                            setValues({
                                                ...values,
                                                ...buildTeacherProfilePatch(userInfo),
                                                refreshKey: Date.now(),
                                            })
                                        }}>
                                        <Button
                                            type="primary"
                                            style={{width: 46, border: '1px solid transparent'}}
                                            icon={
                                                <RiSearch2Line
                                                    size={14}
                                                    className="hover:opacity-85 cursor-pointer"
                                                />
                                            }
                                            className="flex flex-center"
                                        />
                                    </UserLookupComponent>
                                </Space.Compact>
                                {/* Phản hồi UI rõ ràng khi ĐÃ liên kết tài khoản - khớp StudentForm.js
                                    (bạn báo "phải có màu khác, có link đến user chứ không phải text"). */}
                                {form?.values?.user ? (
                                    <LinkedAccountBadge
                                        user={form.values.user}
                                        t={t}
                                        onUnlink={() => {
                                            form.setValues({
                                                ...form.values,
                                                user: null,
                                                user_id: null,
                                                refreshKey: Date.now(),
                                            })
                                        }}
                                    />
                                ) : (
                                    <span className="text-xs text-color-500 italic leading-tight">
                                        {`* `}
                                        {t(
                                            'click on {n} to, lookup user accounts on the {m} platform',
                                            {
                                                n: (
                                                    <RiSearch2Line
                                                        size={13}
                                                        className="mx-1 text-color-000"
                                                    />
                                                ),
                                                m: (
                                                    <span className="font-bold text-blue-600 tracking-widest">
                                                        {'Kristo Network'}
                                                    </span>
                                                ),
                                            }
                                        )}
                                    </span>
                                )}
                            </div>
                        )}
                    </Translate>
                ),
            },
        ],
    },

    date_of_birth__gender: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'date of birth',
                name: 'date_of_birth',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: `${translate('date of birth')} "DD/MM/YYYY"`,
                        // 🔹 Giới hạn ngày
                        disabledDate: (current) => {
                            const maxDate = dayjs().subtract(10, 'year')
                            const minDate = dayjs().subtract(120, 'year')

                            return (
                                current &&
                                (current > maxDate.endOf('day') ||
                                    current < minDate.startOf('day'))
                            )
                        },
                        // 🔹 mở lịch ở khoảng năm hợp lý
                        defaultPickerValue: value ?? dayjs().subtract(30, 'year'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'gender',
                name: 'gender',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange: (value) => {
                            onChange(createValue(name, value))
                        },
                        options: Object.values(GenderTypes)
                    }))
                )(ChipGroup),
            },
        ],
    },
    // place_of_birth__occupation (2 field gộp chung 1 hàng) CHỈ dùng cho CreateTeacherModal - vẫn
    // giữ nguyên, KHÔNG đụng. EditTeacherModal dùng 2 schema tách riêng bên dưới
    // (place_of_birth/occupation) - nơi sinh là thông tin định danh nên gộp cùng Section với ngày
    // sinh/giới tính/giấy tờ tùy thân, còn nghề nghiệp thì không, cần tách ra được 2 Section khác
    // nhau (xem comment ở EditTeacherModal, khớp StudentForm.js).
    place_of_birth__occupation: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'place of birth',
                name: 'place_of_birth',
                component: createControlledFormField({
                    placeholder: 'place of birth',
                    Component: Input,
                }),
            },
            {
                label: 'occupation',
                name: 'occupation',
                component: createControlledFormField({
                    placeholder: 'ex: occupation',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },
    place_of_birth: {
        children: [
            {
                label: 'place of birth',
                name: 'place_of_birth',
                component: createControlledFormField({
                    placeholder: 'place of birth',
                    Component: Input,
                }),
            },
        ],
    },
    occupation: {
        children: [
            {
                label: 'occupation',
                name: 'occupation',
                component: createControlledFormField({
                    placeholder: 'ex: occupation',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },
    id_validator: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                // label: 'identifier code',
                name: 'identifier_code',
                className: 'flex-1',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, form, translate, onChange}) => ({
                        name,
                        onChange,
                        type: 'id code',
                        placeholder: translate('ex: id code'),
                        defaultValue: value,
                        params: {
                            ...{
                                owner_type: form?.values?.owner_type,
                                owner_id: form?.values?.owner_id,
                            },
                            search_type: 'user',
                            input_type: 'identifier_code',
                        },
                        handleApply: (info) => {
                            const {values, setValues} = form ?? {}
                            const {identifier_type, identifier_code} = info ?? {}
                            // Chỉ lưu để xem trước (hint "mã này liên kết với tài khoản...") — KHÔNG
                            // gắn user/user_id vào form ngay lúc gõ. Việc gắn thật chỉ xảy ra lúc bấm
                            // Tạo mới/Lưu, xem onSubmit của CreateTeacherModal/EditTeacherModal.
                            const update = _.omitBy(
                                {
                                    identifier_type: _.find(IdentifierTypes, {
                                        value: identifier_type,
                                    })?.value,
                                    identifier_code: !!String(identifier_code ?? '').length
                                        ? identifier_code
                                        : undefined,
                                    matched_user: info?.id ? info : null,
                                },
                                _.isUndefined
                            )
                            setValues({
                                ...values,
                                ...update,
                            })
                        },
                    }))
                )(IdentifierCodeLookupField),
            },
            {
                // label: 'identifier type',
                name: 'identifier_type',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange: (value) => {
                            onChange(createValue(name, value))
                        },
                        options: Object.values(IdentifierTypes)
                    }))
                )(ChipGroup),
            },
        ],
    },

    contact_email: {
        title: 'email',
        children: [
            {
                name: 'contact_email',
                component: createControlledFormField({
                    type: 'email',
                    placeholder: 'ex: email',
                    Component: Input,
                }),
            },
        ],
    },
    contact_phone: {
        title: 'phone',
        children: [
            {
                name: 'contact_phone',
                component: createPhoneNumberField({
                    placeholder: 'ex: phone',
                    Component: Input,
                }),
            },
        ],
    },
    contact_email__phone: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'email',
                name: 'contact_email',
                // Kèm tìm tài khoản dự phòng qua email khi "Tên đầy đủ" phía trên chưa liên kết - xem
                // giải thích đầy đủ ở AutoLinkEmailInput.js. onApply dùng CHUNG buildTeacherProfilePatch
                // với ô "Tên đầy đủ" (không tạo 2 nguồn sự thật cho việc áp dữ liệu tài khoản vào form).
                component: ({name, value, onChange, form}) => (
                    <AutoLinkEmailInput
                        name={name}
                        value={value}
                        onChange={onChange}
                        form={form}
                        onApply={(foundInfo) => {
                            const {values, setValues} = form ?? {}
                            setValues({
                                ...values,
                                ...buildTeacherProfilePatch(foundInfo),
                                refreshKey: Date.now(),
                            })
                        }}
                    />
                ),
            },
            {
                label: 'phone',
                name: 'contact_phone',
                component: createPhoneNumberField({
                    placeholder: 'ex: phone',
                    autoComplete: false,
                    Component: Input,
                }),
            },
        ],
    },
    contact_address: {
        title: 'address',
        children: [
            {
                name: 'contact_address',
                component: createControlledFormField({
                    showCount: true,
                    maxLength: 500,
                    placeholder: 'ex: address',
                    Component: Input,
                }),
            },
        ],
    },
    active: {
        // title: 'active',
        children: [
            {
                name: 'active',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange: (value) => {
                            onChange(createValue(name, value))
                        },
                        options: [
                            {label: 'active', value: 1},
                            {label: 'inactive', value: 0},
                        ]
                    }))
                )(ChipGroup),
            },
        ]
    },

    majors: {
        title: 'majors',
        children: [
            {
                name: 'majors',
                component: createControlledFormField({
                    autoSize: {minRows: 3, maxRows: 5},
                    placeholder: 'ex: majors',
                    showCount: true,
                    maxLength: 1000,
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    fields: {
        title: 'fields',
        children: [
            {
                name: 'fields',
                component: createControlledFormField({
                    autoSize: {minRows: 3, maxRows: 5},
                    placeholder: 'ex: fields',
                    showCount: true,
                    maxLength: 1000,
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    experiences: {
        title: 'experiences',
        children: [
            {
                name: 'experiences',
                component: createControlledFormField({
                    autoSize: {minRows: 3, maxRows: 5},
                    placeholder: 'ex: experiences',
                    showCount: true,
                    maxLength: 1000,
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    degrees: {
        title: 'degrees',
        children: [
            {
                name: 'degrees',
                component: createControlledFormField({
                    autoSize: {minRows: 3, maxRows: 5},
                    placeholder: 'ex: degrees',
                    showCount: true,
                    maxLength: 1000,
                    Component: Input.TextArea,
                }),
            },
        ],
    },

    hashtags: {
        title: 'category tags',
        children: [
            {
                name: 'hashtags',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: LookupTagsPicker,
                    placeholder: 'tags',
                    apiInfo: {
                        root: API_ROOT_URL,
                        path: '/lookup/teacher_hashtags/gets',
                        method: 'GET',
                        schema: baseItemSchema,
                        transform: createListTransform(baseItemSchema),
                        paramsFields: ['keyword'],
                        fields: ['keyword'],
                    },
                    withProps: ({name, onChange}) => ({
                        onChange: (e, option) => {
                            onChange(createValue(name, e.target.value))
                        },
                    }),
                }),
            },
        ],
    },
}

const runRules = (value, rules) => {
    for (const rule of rules) {
        const error = rule(value)
        if (error) return error
    }
    return null
}

function validateName(name, requireField, keyName, t) {
    const error = {}
    const maxLengthConfig = {
        fullname: 120,
        patron_saint: 180,
        father_name: 255,
        mother_name: 255,
    }
    if (!name && !requireField) return error
    const maxLength = maxLengthConfig[keyName]
    const rules = [
        requireField ? required(t) : null,
        lengthBetween(2, maxLength, t),
        noSpecialChars(t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
        firstLetterUppercase(t),
        eachWordUppercase(t),
    ].filter(Boolean)
    const message = runRules(name, rules)
    if (message) {
        error[keyName] = message
    }
    return error
}

const validateEmail = (email, t) => {
    if (!email) return {}
    const rules = [lengthBetween(5, 120, t), emailFormat(t)]
    const error = runRules(email, rules)
    return error ? {contact_email: error} : {}
}

const validatePhoneNumber = (phone, t) => {
    if (!phone) return {}
    const rules = [digitLength(10, 16, t)]
    const error = runRules(phone, rules)
    return error ? {contact_phone: error} : {}
}

const validateAddress = (address, t) => {
    if (!address) return {}
    const rules = [
        lengthBetween(5, 500, t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
    ]
    const error = runRules(address, rules)
    return error ? {contact_address: error} : {}
}

const validateCategoryTags = (categoryTags, t) => {
    if (!Array.isArray(categoryTags) || categoryTags.length === 0) return {}
    const rules = [
        lengthBetween(2, 255, t),
        noSpecialChars(t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
    ]
    for (const tag of categoryTags) {
        const message = runRules(tag, rules)
        if (message) {
            return {hashtags: message}
        }
    }
}

const validateMajorsOrFieldsOrExperiencesOrDegrees = (value, keyName, t) => {
    const error = {}
    if (!value) return {}
    const rules = [
        lengthBetween(1, 1000, t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
    ]
    const message = runRules(value, rules)
    if (message) {
        error[keyName] = message
    }
    return error
}

const validateIdentityOrDriverLisenceOrPassport = (value, type, t) => {
    if (!value) return {identifier_code: t('required')}
    const rules =
        type === 'identitycard' || type === 'driverlicense'
            ? [digitLength(12, 50, t)]
            : [passportFormart(t)]
    const error = runRules(value, rules)
    return error ? {identifier_code: error} : {}
}

const validateCreateAndEditTeacher = (t) => (values) => {
    const {
        patron_saint,
        fullname,
        identifier_type,
        identifier_code,
        contact_email,
        contact_phone,
        contact_address,
        majors,
        fields,
        experiences,
        degrees,
        hashtags
    } = values ?? {}
    const errorPatronSaint = validateName(
        patron_saint ? patron_saint.value : '',
        false,
        'patron_saint',
        t
    )
    const errorFullname = validateName(fullname, true, 'fullname', t)
    // const errorIdentity = validateIdentityOrDriverLisenceOrPassport(
    //     identifier_code,
    //     identifier_type,
    //     t
    // )
    const errorEmail = validateEmail(contact_email, t)
    const errorPhoneNumber = validatePhoneNumber(contact_phone, t)
    const errorAddress = validateAddress(contact_address, t)
    const errorHashtags = validateCategoryTags(hashtags, t)
    const errorMajors = validateMajorsOrFieldsOrExperiencesOrDegrees(majors, 'majors', t)
    const errorFields = validateMajorsOrFieldsOrExperiencesOrDegrees(fields, 'fields', t)
    const errorExperiences = validateMajorsOrFieldsOrExperiencesOrDegrees(experiences, 'experiences', t)
    const errorDegrees = validateMajorsOrFieldsOrExperiencesOrDegrees(degrees, 'degrees', t)
    return {
        ...errorPatronSaint,
        ...errorFullname,
        // ...errorIdentity,
        ...errorEmail,
        ...errorPhoneNumber,
        ...errorAddress,
        ...errorHashtags,
        ...errorMajors,
        ...errorFields,
        ...errorExperiences,
        ...errorDegrees,
    }
}

export const CreateTeacherModal = ({
                                       owner_id,
                                       owner_type,
                                       initialValues,
                                       onCancel = NullAsDefault,
                                       onSubmit = NullAsDefault,
                                   }) => {
    const t = useTranslate()
    const [isToggle, toggle] = useToggle()

    const _initialValues = useMemo(
        () => ({
            owner_id,
            owner_type,
            avatar: undefined,
            identifier_type: 'identitycard',
            gender: 3,
            ...(initialValues ?? {}),
        }),
        [initialValues, owner_id, owner_type]
    )

    return (
        <Formik
            validate={validateCreateAndEditTeacher(t)}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {
                    owner_id,
                    owner_type,
                    date_of_birth,
                    hashtags = [],
                    matched_user,
                    ...rest
                } = values ?? {}
                onSubmit({
                    ...rest,
                    // Chỉ gắn user/user_id từ tra cứu mã định danh nếu vừa tìm ra kết quả mới —
                    // không đụng tới nếu rest.user/user_id đã được chọn qua ô tìm theo tên (nơi đó
                    // vẫn yêu cầu bấm "Chọn" tường minh, không cần sửa).
                    ...(matched_user ? {user: matched_user, user_id: matched_user.id} : {}),
                    hashtags: !!hashtags ? hashtags.join(',') : undefined,
                    date_of_birth: !!date_of_birth
                        ? getDateString(date_of_birth)
                        : undefined,
                })
            }}>
            {({values}) => {
                const {user, refreshKey} = values ?? {}
                return (
                    <ActionModalWrapper
                        action={<FormActionBar submitText="create"/>}
                        className="gap-4">
                        <Pure input={[refreshKey]}>
                            <div
                                key={refreshKey}
                                className="flex flex-col gap-6">
                                <Section icon={FaUserTie} title={t('teacher information')}>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.patron_saint__fullname,
                                            formSchema.date_of_birth__gender,
                                            formSchema.hashtags,
                                        ]}
                                    />
                                </Section>

                                <Section icon={FaPhone} title={t('contact information')}>
                                    <FieldsFactory formSchema={[formSchema.contact_email__phone, formSchema.contact_address]}/>
                                </Section>

                                <Section icon={FaGraduationCap} title={t('education level')}>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.majors,
                                            formSchema.fields,
                                            formSchema.experiences,
                                            formSchema.degrees,
                                        ]}
                                    />
                                </Section>
                            </div>
                        </Pure>
                    </ActionModalWrapper>
                )
            }}
        </Formik>
    )
}

export const EditTeacherModal = ({
                                     owner_id,
                                     owner_type,
                                     onCancel = NullAsDefault,
                                     onSubmit = NullAsDefault,
                                     initialValues = {},
                                 }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview')

    const _initialValues = useMemo(() => {
        const {date_of_birth, avatar, gender, user, ...rest} = initialValues ?? {}
        return {
            ...rest,
            owner_id,
            owner_type,
            avatar_preview: avatar,
            date_of_birth: parseDayjs(date_of_birth),
            gender: Number(gender),
            // Khớp với dữ liệu đang liên kết sẵn có, để không bị coi là "thay đổi" nếu
            // không đụng tới mã định danh trong lượt sửa này.
            matched_user: user?.id ? user : null,
        }
    }, [initialValues, owner_id, owner_type])

    return (
        <Formik
            validate={validateCreateAndEditTeacher(t)}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                // "user"/"user_id" tách HẲN khỏi shallowDiff, xem giải thích ở StudentForm.js
                // (EditStudentModal) - cùng bug: chọn tài khoản qua ô tìm tên/email không đụng
                // matched_user nên bị bỏ sót khi lọc theo "matched_user in changes".
                const {user, user_id, matched_user: valuesMatchedUser, ...restValues} = values ?? {}
                const changes = shallowDiff(restValues, _initialValues)
                const {
                    owner_id,
                    owner_type,
                    date_of_birth,
                    hashtags = [],
                    ...rest
                } = changes ?? {}

                const initialUserId = _initialValues?.matched_user?.id ?? null
                const identifierChanged = JSON.stringify(valuesMatchedUser ?? null)
                    !== JSON.stringify(_initialValues?.matched_user ?? null)

                let userPatch = {}
                if (identifierChanged) {
                    // Mã định danh vừa được sửa trong lượt này - ưu tiên kết quả tra cứu theo mã định
                    // danh (khớp ai → ghi đè bằng người đó; không khớp ai → gửi null tường minh để gỡ
                    // liên kết cũ, không dùng undefined vì sẽ bị _.omitBy bên dưới lọc mất).
                    userPatch = {user: valuesMatchedUser || null, user_id: valuesMatchedUser?.id ?? null}
                } else if ((user_id ?? null) !== initialUserId) {
                    // Không đụng mã định danh nhưng user/user_id (qua ô tìm tên/email) đã khác giá trị
                    // ban đầu - đây chính là case bị bỏ sót trước đây.
                    userPatch = {user: user ?? null, user_id: user_id ?? null}
                }

                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            ...userPatch,
                            hashtags: !!hashtags ? hashtags.join(',') : undefined,
                            date_of_birth: !!date_of_birth
                                ? getDateString(date_of_birth)
                                : undefined,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <React.Fragment>
                <ForDevelop>
                    <ErrorSummaries/>
                </ForDevelop>
                <ActionModalWrapper
                    className="items-center"
                    tab={current}
                    action={<FormActionBar submitText="save"/>}
                    onTabChange={(key) => {
                        setCurrent(key)
                    }}
                    tabs={[
                        {
                            key: 'overview',
                            label: 'overview',
                            component: ({child}) => (
                                <div className="flex flex-col gap-6">{child}</div>
                            ),
                        },
                        {
                            key: 'about',
                            label: 'about teacher',
                            component: () => (
                                <div className="w-full">
                                    <Section icon={FaGraduationCap} title={t('education level')}>
                                        <FieldsFactory
                                            formSchema={[
                                                formSchema.majors,
                                                formSchema.fields,
                                                formSchema.experiences,
                                                formSchema.degrees,
                                            ]}
                                        />
                                    </Section>
                                </div>
                            ),
                        },
                    ]}>

                    {/* Ảnh đại diện đứng riêng 1 dòng/Section như convention chung (xem ProfileForm.js,
                        vừa áp dụng cho StudentForm.js) - trước gộp chung cột với Section thông tin
                        giáo viên khiến block đầu dày đặc. */}
                    <Section icon={IoImageOutline} title={t('avatar')}>
                        <div className="flex flex-col md:flex-row gap-4">
                            <div className="flex-shrink-0">
                                <FieldsFactory formSchema={[formSchema.avatar]}/>
                            </div>
                            <div className="flex flex-col gap-2 flex-1 min-w-0">
                                <div className="flex items-start justify-between gap-2">
                                    <span className="text-xs font-medium text-color-200 tracking-wider">
                                        {t('teacher portrait photo')}
                                    </span>
                                </div>
                                <p className="text-xs text-color-300 leading-relaxed tracking-wider">
                                    {t('teacher portrait photo hint')}
                                </p>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1.5 p-3 background border border-color-50 rounded-xl">
                                    {[
                                        {icon: <BsInfoCircle size={12} className="text-blue-500 flex-shrink-0"/>, label: t('avatar format hint')},
                                        {icon: <BsAspectRatio size={12} className="text-indigo-500 flex-shrink-0"/>, label: t('avatar ratio hint')},
                                        {icon: <BsExclamationTriangleFill size={12} className="text-rose-500 flex-shrink-0"/>, label: t('avatar max size hint')},
                                        {icon: <BsShieldCheck size={12} className="text-rose-500 flex-shrink-0"/>, label: t('avatar auto optimize hint')},
                                    ].map(({icon, label}, i) => (
                                        <span key={i} className="flex items-center gap-1.5 text-2xs text-color-300 tracking-wider whitespace-no-wrap">
                                            {icon}
                                            {label}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Section>

                    {/* Ngày sinh/nơi sinh/giới tính/giấy tờ tùy thân gộp CHUNG 1 Section (bạn góp ý
                        4 field này "thường là thông tin định danh 1 người", khớp StudentForm.js) -
                        giới tính giữ NGUYÊN vị trí ngay sau ngày sinh (bạn yêu cầu "vẫn để ở trên",
                        không dồn xuống "thông tin khác" như 1 bản chỉnh tay trước đó nữa). */}
                    <Section icon={FaUserTie} title={t('teacher information')}>
                        <FieldsFactory
                            formSchema={[
                                formSchema.patron_saint__fullname,
                                formSchema.date_of_birth__gender,
                                formSchema.place_of_birth,
                            ]}
                        />
                        <Field label={t('identification documents')}>
                            <FieldsFactory formSchema={[formSchema.id_validator]}/>
                            <span className="text-2xs text-color-300 italic tracking-wider">
                                {t('id lookup guidance')}
                            </span>
                        </Field>
                    </Section>

                    {/* Nghề nghiệp + thẻ phân loại KHÔNG phải thông tin định danh - ở lại Section
                        riêng. */}
                    <Section icon={BsInfoCircle} title={t('other information')}>
                        <FieldsFactory
                            formSchema={[
                                formSchema.occupation,
                                formSchema.hashtags,
                            ]}
                        />
                    </Section>

                    <Section icon={FaPhone} title={t('contact information')}>
                        <FieldsFactory formSchema={[formSchema.contact_email__phone, formSchema.contact_address]}/>
                    </Section>

                    {/* Trạng thái hoạt động trước đây là 1 Field trần đứng rời ngoài mọi Section -
                        giờ có khối/nền riêng như các nhóm khác, theme highlight vì ảnh hưởng trực tiếp
                        tới việc giáo viên còn hiển thị/hoạt động hay không (đồng bộ StudentForm.js). */}
                    <Section icon={BsCheckCircleFill} title={t('active')} theme="highlight">
                        <FieldsFactory formSchema={[formSchema.active]}/>
                    </Section>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}
